const autoGeneratePassword = (length = 12) => {
  const charset = {
    lower: "abcdefghijklmnopqrstuvwxyz",
    upper: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    number: "0123456789",
    special: "!@#$%^&*()_+"
  };

  let password = "";

  // Ensure at least one of each required type
  password += charset.lower[Math.floor(Math.random() * charset.lower.length)];
  password += charset.upper[Math.floor(Math.random() * charset.upper.length)];
  password += charset.number[Math.floor(Math.random() * charset.number.length)];
  password += charset.special[Math.floor(Math.random() * charset.special.length)];

  // Fill the rest randomly
  const allChars = charset.lower + charset.upper + charset.number + charset.special;
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle characters (so required chars aren’t always at start)
  password = password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return password;
};

module.exports = autoGeneratePassword;
